import React, { createContext, useContext, useState, useEffect } from 'react';
import { getPrimaryProductImage } from '../utils/productImages';

const WishlistContext = createContext();

export function WishlistProvider({ children }) {
  const [wishlist, setWishlist] = useState(() => {
    try { return JSON.parse(localStorage.getItem('gyro_wishlist')) || []; }
    catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem('gyro_wishlist', JSON.stringify(wishlist));
  }, [wishlist]);

  const toggleWishlist = (product) => {
    setWishlist(prev => {
      if (prev.find(i => i.id === product.id)) return prev.filter(i => i.id !== product.id);
      const primaryImage = getPrimaryProductImage(product);
      return [...prev, {
        id: product.id, name: product.name, price: product.price,
        image1: primaryImage, image2: product.image2, image3: product.image3, image4: product.image4,
        category: product.category, category_name: product.category_name,
      }];
    });
  };

  const removeFromWishlist = (id) => setWishlist(prev => prev.filter(i => i.id !== id));
  const isWishlisted = (id) => wishlist.some(i => i.id === id);
  const wishlistCount = wishlist.length;

  return (
    <WishlistContext.Provider value={{ wishlist, toggleWishlist, removeFromWishlist, isWishlisted, wishlistCount }}>
      {children}
    </WishlistContext.Provider>
  );
}

export function useWishlist() {
  return useContext(WishlistContext);
}
